import { VehicleTableDTO } from '../../../../../Domain/DTO/VehicleTableDTO';

export class SelectVehicleDTO{
    Id: string
    SelectedVehicle: VehicleTableDTO;
    SelectedVehiclesIds: Array<string>;
}